module.exports = __webpack_public_path__ + "img/karta-mundurowa.e6ee2f25.svg";